module.exports = __webpack_public_path__ + "img/jerusalem.0501faf3.jpg";